interface UserInfo {
    name: string;
    title: string;
    email: string;
  }
  
  // Fetch user info from API
  async function loadUserInfo(): Promise<void> {
    try {
      const response = await fetch('/api/info');
      const data: UserInfo = await response.json();
      
      const emailElement = document.getElementById('email');
      if (emailElement) {
        emailElement.textContent = data.email;
      }
    } catch (error) {
      console.error('Error loading user info:', error);
    }
  }
  
  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach((anchor: Element) => {
    anchor.addEventListener('click', function(this: HTMLAnchorElement, e: Event) {
      e.preventDefault();
      const href = this.getAttribute('href');
      if (href) {
        const target = document.querySelector(href);
        target?.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
  
  // Load data when page loads
  window.addEventListener('DOMContentLoaded', loadUserInfo);